import StockDeduction from "./StockDeduction";
import StockEntry from "./StockEntry";
import StockReport from "./StockReport";

export default { StockEntry, StockDeduction, StockReport };
